module.exports = __webpack_public_path__ + "img/05—Applications—VPN server.ad62b650.jpg";